/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Student_1_AchievementInputs */

const en_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013 U.S. Mid-Amateur Champion`)
};

const es_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeón del U.S. Mid-Amateur 2013`)
};

const de_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieger der U.S. Mid-Amateur 2013`)
};

const zh_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Mid-Amateur 2013年冠军`)
};

const ar_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطل U.S. Mid-Amateur 2013`)
};

const fr_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champion U.S. Mid-Amateur 2013`)
};

const vi_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch U.S. Mid-Amateur 2013`)
};

const sw_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bingwa wa U.S. Mid-Amateur 2013`)
};

const th_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์ U.S. Mid-Amateur ปี 2013`)
};

const bs_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion U.S. Mid-Amateur 2013.`)
};

const ja_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013年 U.S. Mid-Amateur 優勝`)
};

const ko_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013 U.S. Mid-Amateur 챔피언`)
};

const pt_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeão do U.S. Mid-Amateur de 2013`)
};

const it_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione U.S. Mid-Amateur 2013`)
};

const sv_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinnare av U.S. Mid-Amateur 2013`)
};

const nl_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winnaar U.S. Mid-Amateur 2013`)
};

const da_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinder af U.S. Mid-Amateur 2013`)
};

const nb_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinner av U.S. Mid-Amateur 2013`)
};

const fi_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoden 2013 U.S. Mid-Amateur -mestari`)
};

const pl_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrz U.S. Mid-Amateur 2013`)
};

const ru_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпион U.S. Mid-Amateur 2013`)
};

const tr_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013 U.S. Mid-Amateur Şampiyonu`)
};

const hi_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013 U.S. Mid-Amateur चैंपियन`)
};

const id_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara U.S. Mid-Amateur 2013`)
};

const ms_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara U.S. Mid-Amateur 2013`)
};

const cs_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vítěz U.S. Mid-Amateur 2013`)
};

const el_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητής U.S. Mid-Amateur 2013`)
};

const he_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלוף U.S. Mid-Amateur 2013`)
};

const af_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013 U.S. Mid-Amateur-kampioen`)
};

const hu_about_content_student_1_achievement = /** @type {(inputs: About_Content_Student_1_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2013-as U.S. Mid-Amateur-bajnok`)
};

/**
* | output |
* | --- |
* | "2013 U.S. Mid-Amateur Champion" |
*
* @param {About_Content_Student_1_AchievementInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_student_1_achievement = /** @type {((inputs?: About_Content_Student_1_AchievementInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Student_1_AchievementInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_student_1_achievement(inputs)
	if (locale === "de") return de_about_content_student_1_achievement(inputs)
	if (locale === "zh") return zh_about_content_student_1_achievement(inputs)
	if (locale === "ar") return ar_about_content_student_1_achievement(inputs)
	if (locale === "fr") return fr_about_content_student_1_achievement(inputs)
	if (locale === "vi") return vi_about_content_student_1_achievement(inputs)
	if (locale === "sw") return sw_about_content_student_1_achievement(inputs)
	if (locale === "th") return th_about_content_student_1_achievement(inputs)
	if (locale === "bs") return bs_about_content_student_1_achievement(inputs)
	if (locale === "ja") return ja_about_content_student_1_achievement(inputs)
	if (locale === "ko") return ko_about_content_student_1_achievement(inputs)
	if (locale === "pt") return pt_about_content_student_1_achievement(inputs)
	if (locale === "it") return it_about_content_student_1_achievement(inputs)
	if (locale === "sv") return sv_about_content_student_1_achievement(inputs)
	if (locale === "nl") return nl_about_content_student_1_achievement(inputs)
	if (locale === "da") return da_about_content_student_1_achievement(inputs)
	if (locale === "nb") return nb_about_content_student_1_achievement(inputs)
	if (locale === "fi") return fi_about_content_student_1_achievement(inputs)
	if (locale === "pl") return pl_about_content_student_1_achievement(inputs)
	if (locale === "ru") return ru_about_content_student_1_achievement(inputs)
	if (locale === "tr") return tr_about_content_student_1_achievement(inputs)
	if (locale === "hi") return hi_about_content_student_1_achievement(inputs)
	if (locale === "id") return id_about_content_student_1_achievement(inputs)
	if (locale === "ms") return ms_about_content_student_1_achievement(inputs)
	if (locale === "cs") return cs_about_content_student_1_achievement(inputs)
	if (locale === "el") return el_about_content_student_1_achievement(inputs)
	if (locale === "he") return he_about_content_student_1_achievement(inputs)
	if (locale === "af") return af_about_content_student_1_achievement(inputs)
	if (locale === "hu") return hu_about_content_student_1_achievement(inputs)
	return en_about_content_student_1_achievement(inputs)
});